import './App.scss';
import QRCode from 'qrcode.react';
import logo from './static/icon.png';
import iOS from './static/ios.png';
import And from './static/Android.png';

function App() {
    return (
        <div className='app'>
            <div className='header'>
            </div>
            <div className='center'>
                <img src={logo}/>
                <p className='name'>倒班日历</p>
                <p>轻 / 松 / 管 / 理 / 排 / 班</p>
                <p>一键设置倒班</p>
            </div>
            <div className='footer'>
                <div className='code'>
                    <QRCode className='qr'
                            value='https://www.moli688.top'// 生成二维码的内容
                            fgColor="#000000" // 二维码的颜色
                            imageSettings={{ // 中间有图片logo
                                excavate: true
                            }}
                    />
                </div>
                <div className='channel'>
                    <p>请下载官方指定App使用</p>
                    <a className='download' href='https://apps.apple.com/cn/app/id1547232838'>
                        <img src={iOS}/>
                        <p>iOS</p>
                    </a>
                    <a className='download' href='https://brush-set.oss-cn-beijing.aliyuncs.com/shift-calendar.apk'>
                        <img src={And}/>
                        <p>Android</p>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default App;
